// src/utils/constants.js — Application-wide constants
export const APP_VERSION = '2.73.0';
export const GOOGLE_CLIENT_ID = '303251710417-33f639tcjrqv0rqmfmngrfpiqpt24ti0.apps.googleusercontent.com';
export const API_BASE = 'https://vdqecojdzu43v4ml7zunth4eoa0xeftt.lambda-url.us-east-1.on.aws';

// Reuse session/timing from inline head beacon (survives CDN script stalls)
export const SESSION_ID = window.__DENTSCRIBE_SESSION_ID || crypto.randomUUID();
export const PAGE_LOAD_TIME = window.__DENTSCRIBE_PAGE_LOAD || Date.now();

// Session token localStorage keys
export const SESSION_TOKEN_KEY = 'dentscribe_session';
export const LEGACY_TOKEN_KEY = 'dentscribe_token';

// PHI retention
export const LOCAL_PHI_RETENTION_DAYS = 7;
export const LOCAL_PHI_RETENTION_MS = LOCAL_PHI_RETENTION_DAYS * 24 * 60 * 60 * 1000;
export const UNSENT_KEPT_KEY = 'dentscribe_unsentKeptCount';
export const UNSENT_SESSION_STATUSES = ['recording', 'paused', 'interrupted', 'pending-upload', 'uploading'];

// Profile inactivity
export const AUTO_LOCK_MINUTES = 15;

// Notes pagination
export const LOAD_NOTES_DEBOUNCE_MS = 2000;

// Network logging limits
export const MAX_NETWORK_LOGS = 20;
export const MAX_UPLOAD_PROGRESS_LOGS = 30;
export const MAX_UPLOAD_DIAGNOSTICS = 5;

// Analytics
export const ANALYTICS_USE_MOCK = false;
export const MAX_RECENT_TYPES = 4;

// Timer display cap
export const MAX_DISPLAY_HOURS = 24;

// User metadata cache key
export const USER_META_KEY = 'dentscribe_user_meta';

// Beacon alias — definition lives in inline <head> script for pre-CDN coverage
export const sendBeacon = window.__sendBeacon || function() {};

// Page titles for sidebar navigation
export const PAGE_TITLES = {
    record: 'Record',
    upload: 'Upload',
    notes: 'Notes',
    admin: 'Admin Dashboard',
    analytics: 'Analytics',
    profile: 'Provider Profile',
    'feature-flags': 'Feature Flags',
};
